import { UiHeaderNavTabModel } from "../../models";

export function mockUiHeaderNavTabModel({
    id = "header-1234",
    type = "uiHeaderNavTab",
    locale = "en",
    content = mockUiHeaderNavTabModelContent()
}: Partial<UiHeaderNavTabModel> = {}): UiHeaderNavTabModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiHeaderNavTabModelContent = UiHeaderNavTabModel["content"];

export function mockUiHeaderNavTabModelContent({
    entryTitle = "Example nav tab",
    title = "Lorem",
    ...optionals
}: Partial<UiHeaderNavTabModelContent> = {}): UiHeaderNavTabModelContent {
    return {
        entryTitle,
        title,
        ...optionals
    };
}
